import * as React from "react";
import { Typography, makeStyles, Button, Box } from "@material-ui/core";
import { Grid } from "ui/grid/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { FunnelCardContainer } from "ui/funnelCardContainer/FunnelCardContainer";
import TextField from "components/design-system/molecules/textField";
import { FunnelSelect } from "ui/funnelSelect/FunnelSelect";
import { MURFY_BOUGHT_ANSWERS, MURFY_REPAIRED_ANSWERS, MURFY_IS_BROKEN_ANSWERS } from "../collectFunnel/constants";
import BrandNameAutocomplete from "components/design-system/organisms/BrandNameAutocomplete";

export const CollectProductDetails = ({
  productIndex,
  handleNextStep,
  handlePreviousStep,
  saveAnswer,
  onChangeBrand,
  onChangeProblem,
  murfyRepaired,
  murfyBought,
  isBroken,
  problem,
  productsToCollect,
  brand,
  noNavigation,
  error,
  buttonText,
  displayMurfyKnownQuestions,
}) => {
  const classes = useStyles();

  const isNavigationDisabled =
    !brand ||
    brand?.length < 1 ||
    (displayMurfyKnownQuestions && (!murfyBought || !murfyRepaired)) ||
    !isBroken ||
    (isBroken.value && !problem);

  const navigationButtons = (
    <Grid container item justify="space-between" className={classes.buttons}>
      <Grid item>
        {handlePreviousStep && !noNavigation && (
          <Button startIcon={<ArrowBackIcon />} color="secondary" onClick={() => handlePreviousStep()}>
            Retour
          </Button>
        )}
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          className={classes.validationButton}
          onClick={() => handleNextStep(productIndex)}
          disabled={isNavigationDisabled}
        >
          {productIndex < productsToCollect.length - 1 ? "Produit suivant" : buttonText}
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <FunnelCardContainer>
      <Box mb={6}>
        <Box mb={1}>
          <Typography variant="body2" mb={2}>
            Appareil {productIndex + 1} - {productsToCollect[productIndex]?.type}
          </Typography>
        </Box>
        <Box mb={2}>
          <Typography color="secondary" variant={"h3"}>
            Quelle est la marque de votre appareil ?
          </Typography>
        </Box>
        <BrandNameAutocomplete
          key={productIndex}
          onUpdate={(event) => onChangeBrand(event.target.textContent)}
          defaultValues={{ brand: brand }}
          onBlurNotExistingBrand={(event) => onChangeBrand(event.target.value)}
        />
      </Box>
      {displayMurfyKnownQuestions && (
        <>
          <Box mb={5}>
            <Box mb={2}>
              <Typography color="secondary" variant={"h3"}>
                Avez vous acheté votre appareil chez Murfy ?
              </Typography>
            </Box>
            <FunnelSelect
              key={productIndex}
              from={MURFY_BOUGHT_ANSWERS}
              keyToDisplay="text"
              onSelect={saveAnswer}
              defaultValue={murfyBought?.index}
            />
          </Box>
          <Box mb={5}>
            <Box mb={2}>
              <Typography color="secondary" variant={"h3"}>
                Sommes-nous déjà intervenus sur votre appareil ?
              </Typography>
            </Box>
            <FunnelSelect
              key={productIndex}
              from={MURFY_REPAIRED_ANSWERS}
              keyToDisplay="text"
              onSelect={saveAnswer}
              defaultValue={murfyRepaired?.index}
            />
          </Box>
        </>
      )}
      <Box mb={5}>
        <Box mb={2}>
          <Typography color="secondary" variant={"h3"}>
            Votre appareil fonctionne-t-il normalement ?
          </Typography>
        </Box>

        <FunnelSelect
          key={productIndex}
          from={MURFY_IS_BROKEN_ANSWERS}
          keyToDisplay="text"
          onSelect={saveAnswer}
          defaultValue={isBroken?.index}
        />
      </Box>
      {isBroken?.value && (
        <Box mb={5}>
          <Box mb={2}>
            <Typography color="secondary" variant={"h3"}>
              Pouvez vous décrire la panne rencontrée ?
            </Typography>
          </Box>
          <TextField
            key={productIndex}
            multiline
            rows={4}
            label={"Décrivez votre panne"}
            fullWidth
            value={problem}
            onChange={(event) => onChangeProblem(event.target.value)}
          />
        </Box>
      )}
      {error && (
        <Box mt={1} color={"red"}>
          <Typography variant="body2">{error}</Typography>
        </Box>
      )}
      {!noNavigation && navigationButtons}
    </FunnelCardContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  validationButton: { padding: theme.spacing(2) },
  buttons: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      zIndex: 5,
      position: "fixed",
      margin: 0,
      bottom: 0,
      left: 0,
      padding: theme.spacing(1),
      backgroundColor: theme.palette.common.white,
      borderTop: "1px solid #D7D7D7",
    },
  },
}));
